import React from 'react';
import { Link } from 'gatsby';
import { Image, Wrapper } from '..';
import './StoryFeaturedImage.scss';

const StoryFeaturedImage = (props) => {
  const {
    storyName,
    category,
    featuredImage,
    siteMetadata,
  } = props;
  const {
    storiesSlug,
    categorySlug,
  } = siteMetadata;
  const { uid: storyCategorySlug } = category;
  const categoryData = category.document['0'].data || {};
  const { categoryName } = categoryData;
  return (
    <section className="story-featured-image">
      <Wrapper>
        <div className="container">
          <div className="annotations">
            <Link
              className="category-link"
              to={`/${storiesSlug}/${categorySlug}/${storyCategorySlug}/`}
              aria-label={`View more ${categoryName.text} stories`}
            >
              <svg className="icon" viewBox="0 0 21 15" xmlns="http://www.w3.org/2000/svg">
                <path d="M2.835 6.673h16.97a.85.85 0 0 1 0 1.7H2.877l4.89 5.193c.211.223.285.54.193.832a.864.864 0 0 1-.638.58.882.882 0 0 1-.833-.251L.23 8.08a.844.844 0 0 1-.228-.532.842.842 0 0 1 .228-.628L6.49.273a.882.882 0 0 1 .833-.252c.303.068.547.29.638.58a.841.841 0 0 1-.194.833L2.835 6.673z" fillRule="evenodd" />
              </svg>
              <span>{`${categoryName.text} Stories`}</span>
            </Link>
            <span>{storyName.text}</span>
          </div>
          <div className="featured-photo-container">
            <Image image={featuredImage} />
          </div>
        </div>
      </Wrapper>
    </section>
  );
};

export default StoryFeaturedImage;
